import { useNavigate } from "react-router-dom";
import { ButtonSearchComponent, InputSearchComponent } from "../../components";

export const CouponSearchContainer = () => {
  const navigate = useNavigate();
  const filter = () => {
    const search = document.getElementById("searchCoupon").value;
    let url = `/cupones?`;
    if (search !== "null") {
      url = url.concat(`&search=${search}`);
    }
    navigate(url);
  };
  const handleEnter = (e) => {
    if (e.key !== "Enter") return;
    filter();
  };
  const dataInput = { id: "searchCoupon", placeholder: "Buscar cupon" };
  return (
    <div className="clientSearchContainer">
      <div className="clientSearchContainer__search">
        <div className="clientSearchContainer__search__input">
          <InputSearchComponent data={dataInput} onKeyDown={handleEnter} />
        </div>
        <div className="clientSearchContainer__search__button">
          <ButtonSearchComponent filter={filter} />
        </div>
      </div>
    </div>
  );
};
